import config from "@config/index";
import logout from "@utils/js/Logout";
import { deleteAuthorizationToken, deleteAllCookies } from "@utils/js/helper";


export const debounce = (func, delay) => {
  let timer;
  return function closure(...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, delay);
  };
};

export const autoLogout = () => {
  localStorage.setItem(config.LOGOUT_EVENT_KEY, false);

  window.addEventListener('storage', (event) => {
    if (event.key === config.LOGOUT_EVENT_KEY && event.newValue === 'true') {
      logout();
    }
  });
};

export const redirectToLogin = () => {
  const { origin } = window.location;
  let redirectToLoginUrl = `${config.API_PATH_TOOLS}${config.API_PATH.LOGIN}`;
  if (origin.indexOf('developer.gartner.com') !== -1) {
    redirectToLoginUrl = `${config.GENIE_AUTH_URL}`;
  }
  redirectToLoginUrl += `?TARGET=${encodeURIComponent(origin)}${config.BASE_URL}${config.GENIE_AUTH_PARAMS}`;
  deleteAuthorizationToken(config.TOKEN_KEY_INFO);
  deleteAuthorizationToken(config.GAP_ADMIN_IDENTIFIER);
  deleteAuthorizationToken(config.USER_SESSION_IDENTIFIER);
  deleteAllCookies();
  localStorage.setItem(config.LOGOUT_EVENT_KEY, 'true');
  localStorage.removeItem('ubpEnabled');
  window.location.replace(redirectToLoginUrl);
}
